import { createSelector } from '@ngrx/store';
import { getOnlineMenuVirtualLocations } from '../getOnlineMenuVirtualLocations/get-online-menu-virtual-locations.selector';

export const getOnlineMenuVirtualLocationsData = createSelector(getOnlineMenuVirtualLocations, (onlineMenuVirtualLocations) =>
    onlineMenuVirtualLocations.map((onlineMenu) => onlineMenu.data),
);
